<template>
  <div>
    <div class="search-mobile-BG cursor-default" @click.stop="removeAutocomplete" v-if="autocompleteList"></div>
    <div class="search-mobile text-NotoSansRegular z-50">
      <div class="flex py-2 px-4 w-full">
        <div class="search-container flex items-center justify-between border border-gray-500 bg-white w-full rounded pl-3  focus:outline-none" tabindex="0">
          <input placeholder="Search" type="text" class="m-0 text-base text-NotoSansRegular focus:outline-none w-full"
            v-model="searchVal" autofocus
            v-on:keyup.13="searchItem" aria-label="Search">
          <div class="searchButton px-2 py-2 textColor-searchBar border-r cursor-pointer" @click.prevent="searchVal = ''" v-if="searchVal">
            <font-awesome-icon icon="times" />
          </div>
          <div class="searchButton px-3 py-2 textColor-searchBar cursor-pointer" @click.prevent="searchItem">
            <font-awesome-icon icon="search" />
          </div>
        </div>
      </div>
      <div class="autocomplete-mobile z-50" v-if="autocompleteList !== null">
        <ul class="z-50">
          <li v-for="(item,index) in autocompleteList" :key="index">
            <a class="px-3 py-2 block border autoText" @click.prevent="autocompleteSearch(item)">
              {{ item }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SearchMobile',

  data () {
    return {
      searchVal: '',
      autocompleteList: null
    }
  },
  watch: {
    searchVal: {
      handler (newValue, oldValue) {
        let self = this
        if (newValue !== oldValue) {
          self.autocomplete()
        }
      }
    }
  },
  props: {
    isSearch: {
      type: Boolean
    }
  },
  computed: {
  },
  mounted () {
  },
  updated () {
    this.removeAutocomplete()
  },
  methods: {
    searchItem () {
      let self = this
      if (self.searchVal !== '') {
        self.$router.push({ name: 'SearchResult', query: { keyword: self.searchVal } })
      }
    },
    autocompleteSearch (item) {
      let self = this
      self.searchVal = item
      self.autocompleteList = null
      self.$router.push({ name: 'SearchResult', query: { keyword: self.searchVal } })
    },
    removeAutocomplete () {
      let self = this
      if (self.searchVal === self.$route.query.keyword) {
        self.autocompleteList = null
      }
    },
    autocomplete () {
      let self = this
      if (self.searchVal !== '') {
        axios.get('/autocomplete/products?q=' + self.searchVal)
          .then((response) => {
            let list = []
            for (let item of response.data) {
              list.push(item.name)
            }
            self.autocompleteList = list
          }
          )
      } else {
        self.autocompleteList = null
      }
    }
  }
}
</script>

<style lang="scss">
.search-mobile-BG {
  position: fixed;
  top: 108px;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: -1;
  animation-name: bgMobile;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}
  @keyframes bgMobile {
    from {
      background: rgba(0, 0, 0, 0);
    }
    to {
      background: rgba(0, 0, 0, 0.35);
    }
  }
.autoText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-mobile {
  z-index: 99 !important;
}
.autocomplete-mobile {
  z-index: 1002;
  transition: left .3s ease-out;
  &::before {
    background-color: transparent !important;
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-left: 11px solid transparent;
    border-right: 11px solid transparent;
    border-bottom: 11px solid;
    border-bottom-color: #fff;
    margin-left: 193px;
  }
  ul {
    li {
      background-color: white !important;
      .autoText {
        width: 32em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
